import { render, staticRenderFns } from "./iconPosition.vue?vue&type=template&id=d89ed728&scoped=true&"
import script from "./iconPosition.vue?vue&type=script&lang=js&"
export * from "./iconPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89ed728",
  null
  
)

export default component.exports